import { Uuid } from "./uuid";
import { NaiveDateTime } from "./datetime";
import { AnaglyphOrientation } from "../lib/anaglyph_orientation";

export class ClinicUserPerms {
    view_tools: boolean;
    view_printables: boolean;
    view_progress_report: boolean;
}

export interface WhiteLabelPrefs {
    primary_colour?: string | null;
    secondary_colour?: string | null;
    dark_mode?: boolean;
    logo?: Uuid | null;
    email_template_invitation?: string | null;
    email_template_password_recovery?: string | null;
}

export default class ClinicPrefs {
    clinic_id: Uuid;
    created: NaiveDateTime;
    updated: NaiveDateTime;
    default_user_perms: ClinicUserPerms;
    user_signup_token: string | null;
    whitelabel: WhiteLabelPrefs;
    custom_help_text?: string | null;
    default_anaglyph_orientation?: AnaglyphOrientation | null;
    disallow_different_glasses: boolean;

    static fromJson(data: Object): ClinicPrefs {
        let prefs = new ClinicPrefs();
        Object.assign(prefs, data);        
        return prefs;
    }
}
